<template>
  <el-form-item
    :label="label"
    class="postal-code"
    :prop="prop"
    :rules="rules"
  >
    <el-input
      v-model="postalCode"
      type="text"
      :clearable="true"
      :maxlength="8"
      resize="none"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '郵便番号'
    },
    prop: {
      type: String,
      default: 'postal_code'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '半角数字（ハイフンあり）'
    }
  },
  computed: {
    postalCode: {
      get () {
        return this.value
      },
      set (postalCode) {
        this.$emit('input', postalCode)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
          if (!this.searchCond) {
            rules.push(this.validatorZip(this.label, 'blur'))
          } else {
            rules.push(this.validatorRegExp(this.label, '^[0-9\\-]+$', '郵便番号(999-9999)', 'blur'))
          }
        }
        return rules
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
